import { Autocomplete, Box, TextField } from '@mui/material';
import type { Country } from 'countries-list';
import { countries } from 'countries-list';
import React from 'react';

type CountrySelectProps = {
  value?: Country | null;
  onChange?: (country: Country | null) => void;
  textFieldProps?: React.ComponentProps<typeof TextField>;
};

export const CountrySelect: React.FC<CountrySelectProps> = ({ value, onChange, textFieldProps }) => {
  return (
    <Autocomplete
      fullWidth
      autoHighlight
      getOptionLabel={(option) => option.name}
      size="small"
      options={Object.values(countries)}
      renderOption={({ key, ...optionProps }, option) => (
        <Box
          key={key}
          component="li"
          sx={{ columnGap: '20px', display: 'flex' }}
          {...optionProps}
        >
          {`${option.emoji} ${option.name}`}
        </Box>
      )}
      renderInput={(params) => (
        <TextField
          {...params}
          {...textFieldProps}
          inputProps={{
            ...params.inputProps,
            autoComplete: 'new-password',
          }}
        />
      )}
      value={value}
      onChange={(_event, newValue) => {
        _event.preventDefault();
        onChange?.(newValue);
      }}
    />
  );
};